import {use} from 'react'

import {NativeAhpTimelineErrorContext, NativeAhpTimelineStateContext} from '../contexts/NativeAhpContext'
import {useOptionalEstablishedAhpSession} from './use-established-ahp-session'
import {useOptionalEstablishedAhpSessionViewState} from './use-established-ahp-session-view'

/**
 * The timeline state a composer or meter should read.
 *
 * An established session is the authority on its own state, so it wins. Only a
 * surface without one falls back to the state its host provider publishes.
 */
export function useNativeAhpTimelineState() {
  const establishedSession = useOptionalEstablishedAhpSession()
  const establishedView = useOptionalEstablishedAhpSessionViewState()
  const fallback = useNativeAhpTimelineFallbackState()
  return establishedSession ? {state: establishedView.state, errorMessage: establishedView.error} : fallback
}

export function useNativeAhpTimelineFallbackState() {
  const state = use(NativeAhpTimelineStateContext)
  const errorMessage = use(NativeAhpTimelineErrorContext)
  if (state === null || errorMessage === null) {
    throw new Error('useNativeAhpTimelineState must be used within AhpProvider')
  }
  return {state, errorMessage}
}
